import { Component } from '@angular/core';
import { ProductsComponent } from './products.component';

@Component({
  selector: 'eid-products-desktop',
  templateUrl: './products.desktop.component.html',
  styleUrls: ['./products.desktop.component.scss']
})
export class ProductsDesktopComponent extends ProductsComponent {}
